import { createSelector } from 'reselect';

const selectAccountCategories = (state: any) => state.accountCategories;


export const selectAccountCategoriesCurrentItem = createSelector([selectAccountCategories], (accountCategories) => accountCategories.current);

export const selectAccountCategoriesListItems = createSelector([selectAccountCategories], (accountCategories) => accountCategories.list);

export const selectAccountCategoriesItemById = (itemId: any) =>
    createSelector(selectAccountCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountCategoriesQueryItems = createSelector([selectAccountCategories], (accountCategories) => accountCategories.query);

export const selectAccountCategoriesCreatedItem = createSelector([selectAccountCategories], (accountCategories) => accountCategories.create);

export const selectAccountCategoriesUpdatedItem = createSelector([selectAccountCategories], (accountCategories) => accountCategories.update);

export const selectAccountCategoriesReadItem = createSelector([selectAccountCategories], (accountCategories) => accountCategories.read);

export const selectAccountCategoriesDeletedItem = createSelector([selectAccountCategories], (accountCategories) => accountCategories.delete);

export const selectAccountCategoriesSearchedItems = createSelector([selectAccountCategories], (accountCategories) => accountCategories.search);

export const selectAccountCategoriesItemsCount = createSelector([selectAccountCategories], (accountCategories) => accountCategories.count);

export const selectAccountCategoriesItemsFilter = createSelector([selectAccountCategories], (accountCategories) => accountCategories.filter);